import React, { useEffect } from "react";
import { Mail, MapPin } from "lucide-react";
import { SITE } from "../data/mock";

export default function Contact() {

  useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
  
      script.addEventListener('load', () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: "48114061",
            formId: "a258f3d1-c2d3-4788-948e-6cd297519556",
            region: "na1",
            target: '#hubspotFormContact',
          });
        }
      });
  }, []);


  return (
    <div>
      <section className="bg-[#f4f5f7] py-14 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <h1 className="text-4xl font-semibold text-slate-800">Contact Us</h1>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-2 gap-14">
        <div>
          <p className="text-slate-600 leading-relaxed text-lg">
            Reach out to our team by phone, email, or by{" "}
            <a href="#contactform" className="text-[#29abe2] hover:underline">
              filling out the contact form below.
            </a>
          </p>

          <div className="mt-8 overflow-hidden rounded-md shadow-sm">
            <img
              src="/images/toronto-sign.jpg"
              alt="Toronto sign at Nathan Phillips Square"
              className="w-full h-64 md:h-72 object-cover"
              loading="lazy"
            />
          </div>

          <div className="mt-10 space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-[#29abe2]/10 flex items-center justify-center flex-shrink-0">
                <MapPin className="w-5 h-5 text-[#29abe2]" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-slate-800">Proudly Based in Toronto 🇨🇦</h3>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-[#29abe2]/10 flex items-center justify-center flex-shrink-0">
                <Mail className="w-5 h-5 text-[#29abe2]" />
              </div>
              <div>
                <a href={`mailto:${SITE.email}`} className="text-xl font-semibold text-slate-800 hover:text-[#29abe2]">
                  {SITE.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div id="contactform">
          <h2 className="text-3xl font-semibold text-slate-800 mb-6">Contact</h2>
          <div id="hubspotFormContact" className="space-y-5"/>
        </div>
      </div>
    </div>
  );
}
